import { Switch } from '@mantine/core';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scoped.css';

export function Toogle({
  input,
  value,
  checked,
  inputProps,
  valueLabel,
  color,
}) {
  const onChange = (e) => {
    input.onChange(e);
  };
  return (
    <>
      <label>
        {inputProps.label}
        {inputProps.required && <span className={styles.withAsterisk}> *</span>}
      </label>
      <Switch
        checked={checked}
        classNames={{ track: 'track' }}
        color={color}
        offLabel={inputProps.offLabel}
        onChange={onChange}
        onLabel={inputProps.onLabel}
        size="md"
        value={value}
      />
      {valueLabel ? <span className={styles.info}>{valueLabel}</span> : null}
    </>
  );
}

export default Toogle;

Toogle.propTypes = {
  checked: PropTypes.bool,
  color: PropTypes.string,
  input: PropTypes.object,
  inputProps: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.bool,
  valueLabel: PropTypes.string,
};

// Provide defaultProps to satisfy tests accessing Toogle.defaultProps and avoid undefined accesses
Toogle.defaultProps = {
  checked: false,
  color: 'blue',
  input: { value: false, onChange: () => {} },
  inputProps: { label: '', required: false, offLabel: '', onLabel: '', rightSection: null },
  onChange: () => {},
  value: false,
  valueLabel: '',
};
